module.exports = __webpack_public_path__ + "static/spyfallplus-app-icon-57157d221c3611e74d0164ba6b9d23c2.png";